import { render, staticRenderFns } from "./ImageRightsModal.vue?vue&type=template&id=a75f68ea&scoped=true"
import script from "./ImageRightsModal.vue?vue&type=script&lang=js"
export * from "./ImageRightsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a75f68ea",
  null
  
)

export default component.exports